import { Params, Router } from '@angular/router';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { AuthenticationService } from '@mpt-fo/common/core/services/authentication.service';
import { TimelineModel } from '@mpt-fo/common/shared/models/timeline.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-face-validation',
	templateUrl: './face-validation.component.html',
	styleUrls: ['./face-validation.component.scss']
})
export class FaceValidationComponent implements OnInit {
	@Input() step: TimelineModel;
	@Input() stepsArray: TimelineModel[];
	@Output() back: EventEmitter<any> = new EventEmitter();
	@Output() continue: EventEmitter<any> = new EventEmitter();
	errorMessage: string;
	images = [];
	submitting: boolean;
	username: any;
	livelinessKey: any;

	constructor(
		private auth: AuthenticationService,
		private router: Router

	) { }

	ngOnInit(): void {
		this.username = this.stepsArray[0]?.data?.username;
	}

	next(images) {
		this.images = images;
		this.doFaceCheck();
	}

	doFaceCheck() {
		this.errorMessage = null;
		this.submitting = true;
		const body = this.buildObj();
		this.auth.doFaceMatchCheck(body).then(res => {
			this.step.response = res;
			this.livelinessKey = res.livelinessKey;
			this.submitting = false;
			this.gotoPasswordChange();
		}).catch(err => {
			this.errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
			this.submitting = false;
		});
	}

	gotoPasswordChange() {
		const username = encodeURIComponent(this.username);
		const token = encodeURIComponent(this.livelinessKey);
		const params: Params = { username, token };
		this.router.navigate([`recover-password`], { queryParams: params });
	}

	buildObj() {
		const obj: LivelinessObject = {
			image1: this.images[0],
			image2: this.images[1],
			username: this.username,
			validationKey: this.stepsArray[1]?.response?.validationKey
		};
		return obj;
	}
}

interface LivelinessObject {
	image1;
	image2;
	username;
	validationKey;
}
